var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.788 16.064C27.26 16.304 26.732 16.448 26.108 16.544C26.684 16.16 27.164 15.632 27.404 14.96C26.828 15.296 26.204 15.536 25.58 15.68C25.052 15.104 24.284 14.768 23.468 14.768C21.884 14.768 20.54 16.064 20.54 17.696C20.54 17.936 20.588 18.128 20.636 18.368C18.236 18.272 16.076 17.072 14.636 15.344C14.396 15.68 14.252 16.16 14.252 16.688C14.252 17.696 14.78 18.608 15.548 19.088C15.068 19.088 14.636 18.944 14.252 18.704V18.752C14.252 20.144 15.26 21.344 16.604 21.584C16.364 21.632 16.124 21.68 15.836 21.68C15.644 21.68 15.452 21.68 15.308 21.632C15.692 22.784 16.748 23.648 18.044 23.648C17.036 24.416 15.788 24.896 14.444 24.896C14.204 24.896 13.964 24.896 13.772 24.848C14.924 25.76 16.46 26.24 18.092 26.24C23.42 26.24 26.348 21.824 26.348 17.984V17.6C26.924 17.168 27.404 16.688 27.788 16.064Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4c102107.svg";
export { ForwardRef as ReactComponent };